import { useState, useEffect, lazy, Suspense } from "react";
import { Routes, Route, Navigate, useLocation, Outlet /* , useNavigate */ } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Sidenav from "ui/Sidenav";
import theme from "assets/theme";
import themeDark from "assets/theme-dark";

import { useMaterialUIController, setMiniSidenav } from "context";

import logo from "assets/images/identite/logo.png";
import routesData /* , { routeGeolocation, routeReproduction } */ from "router/routes";

import { /* LAST_PATH, */ USER_DATA_STORAGE } from "constant";
import SuspenceComponent from "components/SuspenceComponent";
import LayoutWrapper from "components/LayoutWrapper";

import {
  PATH_LOT,
  PATH_ANIMAUX,
  PATH_RACE,
  PATH_DETAIL_USER,
  PATH_DETAIL_ANIMAL,
  PATH_DETAIL_DEMANDE_IDENTIFICATION,
  PATH_NEW_DEMANDE_IDENTIFICATION,
  // PATH_ENTITE_DETAIL,
  PATH_DETAIL_PUCE,
  PATH_DETAIL_LOT_PUCE,
  // DEFAULT_PATH,
  // PATH_DASHBOARD_COMPAGNIE,
  /* PATH_DETAIL_CAMPAGNE_INTERVENTION,
  PATH_DETAIL_INTERVENTION,
  PATH_DETAIL_LOT_INTERVENTION,
  PATH_DETAIL_LOT_INTRANT,
  PATH_DETAIL_SEMENCE,
  PATH_DETAIL_INSEMINATION,
  PATH_DETAIL_MISE_BAS,
  PATH_DETAIL_PRODUIT_MISE_BAS, */
} from "constant/moduleInfo";
import DetailUser from "layouts/gestionUsers/rubrique/DetailUser";

import DetailAnimal from "layouts/gestionAnimaux/DetailAnimal";
import DetailDemandeIdentification from "layouts/gestionAnimaux/DetailDemandeIdentification";

import NewDemandeIdentification from "layouts/gestionAnimaux/NewDemandeIdentification";

// import DetailEntite from "layouts/donneeReference/rubrique/gestionEntite/DetailEntite";
import DetailPuce from "layouts/donneeReference/rubrique/gestionPuce/DetailPuce";
import DetailLotPuce from "layouts/donneeReference/rubrique/gestionLotPuce/DetailLotPuce";

/* import DetailCampagneIntervention from "layouts/reproduction/rubrique/campagneIntervention/DetailPage";
import DetailIntervention from "layouts/reproduction/rubrique/Intervention/DetailPage";
import DetailLotIntervention from "layouts/reproduction/rubrique/lot_intervention/DetailPage";
import DetailLotIntrant from "layouts/reproduction/rubrique/lot_intrant/DetailPage";
import DetailSemence from "layouts/reproduction/rubrique/semence/DetailPage";
import DetailInsemination from "layouts/reproduction/rubrique/insemination/DetailPage";
import DetailMisebas from "layouts/reproduction/rubrique/misebas/DetailPage";
import DetailProduitMisebas from "layouts/reproduction/rubrique/produitMisebas/DetailPage"; */

const SignIn = lazy(() => import("layouts/authentication/sign-in"));

const Error404 = lazy(() => import("layouts/error404/Error404"));
const GestionLot = lazy(() => import("layouts/donneeReference/rubrique/gestionLot"));
const GestionRace = lazy(() => import("layouts/donneeReference/rubrique/gestionRace"));
const Logout = lazy(() => import("layouts/authentication/sing-out"));
const GestionAnimaux = lazy(() => import("layouts/gestionAnimaux"));

// const routesData = routes;

/* const isSessionExpired = (UserInfo) => {
  const currentDate = new Date();
  if (UserInfo !== null && UserInfo.exp * 1000 < currentDate.getTime()) {
    return true;
  }
  return false;
}; */
const useAuth = () => {
  /* let UserInfo = null;
  if (localStorage.getItem(USER_DATA_STORAGE) !== null) {
    UserInfo = JSON.parse(localStorage.getItem(USER_DATA_STORAGE));
  }
  if (UserInfo !== null && UserInfo !== "" && UserInfo !== "{}" && UserInfo !== undefined) {
    const currentDate = new Date();
    if (UserInfo.exp * 1000 > currentDate.getTime()) {
      return true;
    }
    return false;
  }
  return false; */
  // console.log("useAuth called", localStorage.getItem(USER_DATA_STORAGE) !== null);
  return localStorage.getItem(USER_DATA_STORAGE) !== null;
};
export default function App() {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, direction, layout, sidenavColor, darkMode } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  // const [defaultPath /* , setdefaultPath */] = useState("/");
  const { pathname } = useLocation();
  const [isAuth, setIsAuth] = useState(false);
  // const [routesData, setRoutesData] = useState(routes);
  // const navigate = useNavigate();
  const setTabTitle = () => {
    let tabTitle = "BetaClic";
    let isUser = false;
    if (localStorage.getItem(USER_DATA_STORAGE) !== null) {
      const userInfo = JSON.parse(localStorage.getItem(USER_DATA_STORAGE));

      if (userInfo !== null && userInfo.entite !== null && userInfo.entite !== undefined) {
        tabTitle = `BetaClic | ${userInfo.entite?.name}`;
      }
      isUser = true;
    }
    document.title = tabTitle;
    setIsAuth(isUser);
  };
  useEffect(() => {
    // const AuthBool = useAuth();

    //  setIsAuth(AuthBool);
    // console.log("changed connectedUserInfo", connectedUserInfo);
    setTabTitle();
  }, [localStorage.getItem(USER_DATA_STORAGE)]);

  /* useEffect(() => {
    let UserInfo = null;
    if (localStorage.getItem(USER_DATA_STORAGE) !== null) {
      UserInfo = JSON.parse(localStorage.getItem(USER_DATA_STORAGE));
    }
    const AuthBool = useAuth();
    if (AuthBool) {
      let userRoles = [];
      if (UserInfo !== null) {
        userRoles = UserInfo.roles;
      }
      const dataRes = [];
      routesData.forEach((i, idx, arr) => {
        const isAvalaible = i.role
          .map((el1) => ({
            name: el1,
            match: userRoles.some((el2) => el2.roleName.toLowerCase() === el1.toLowerCase()),
          }))
          .some((x) => x.match === true);
        if (isAvalaible) {
          dataRes.push(i);
        }
        if (idx === arr.length - 1) {
          return dataRes;
        }
        return "success";
      });

      if (dataRes.length > 0 && dataRes[0].route) {
        setdefaultPath(dataRes[0].route);
        const lastPath = localStorage.getItem(LAST_PATH);
        if (lastPath === null) {
          if (Array.isArray(dataRes) && dataRes.length > 0) {
            navigate(dataRes[0].route);
          }
        }
      } else {
        alert(
          "Vous n'êtes pas authorisé à accéder à cette plateforme. Contactez votre administrateur"
        );
      }
    } else {
      console.log("Betaclic");
      if (UserInfo !== null && isSessionExpired(UserInfo)) {
        const tabTitle = "BetaClic";
        document.title = tabTitle;
        alert("Votre session a expirée");
      }
    }
  }, []); */

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  const DEFAULT_PATH = routesData?.[0]?.route;

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route?.collapse?.length > 0) {
        return getRoutes(route.collapse);
      }
      return (
        <Route
          path={route.route}
          element={<LayoutWrapper>{route.component}</LayoutWrapper>}
          key={route.key}
        />
      );
    });
  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      {layout === "dashboard" && isAuth && (
        <Sidenav
          color={sidenavColor}
          brand={logo}
          routes={routesData}
          onMouseEnter={handleOnMouseEnter}
          onMouseLeave={handleOnMouseLeave}
        />
      )}
      <Routes>
        <Route exact path="/" element={<ProtectedRoutes />}>
          <Route path="/" element={<Navigate replace to={DEFAULT_PATH} />} />
          {getRoutes(routesData)}
          <Route
            path="*"
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <Error404 />
              </Suspense>
            }
          />
          <Route
            path="/logout"
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <Logout />
              </Suspense>
            }
          />
          <Route
            path={PATH_LOT}
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <LayoutWrapper>
                  <GestionLot />
                </LayoutWrapper>
              </Suspense>
            }
          />
          <Route
            path={PATH_ANIMAUX}
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <LayoutWrapper>
                  <GestionAnimaux />
                </LayoutWrapper>
              </Suspense>
            }
          />
          <Route
            path={PATH_RACE}
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <LayoutWrapper>
                  <GestionRace />
                </LayoutWrapper>
              </Suspense>
            }
          />
          <Route
            path={PATH_DETAIL_USER}
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <LayoutWrapper>
                  <DetailUser />
                </LayoutWrapper>
              </Suspense>
            }
          />
          <Route
            path={PATH_DETAIL_ANIMAL}
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <LayoutWrapper>
                  <DetailAnimal />
                </LayoutWrapper>
              </Suspense>
            }
          />
          <Route
            path={PATH_DETAIL_PUCE}
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <LayoutWrapper>
                  <DetailPuce />
                </LayoutWrapper>
              </Suspense>
            }
          />
          <Route
            path={PATH_DETAIL_LOT_PUCE}
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <LayoutWrapper>
                  <DetailLotPuce />
                </LayoutWrapper>
              </Suspense>
            }
          />
          <Route
            path={PATH_DETAIL_DEMANDE_IDENTIFICATION}
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <LayoutWrapper>
                  <DetailDemandeIdentification />
                </LayoutWrapper>
              </Suspense>
            }
          />
          <Route
            path={PATH_NEW_DEMANDE_IDENTIFICATION}
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <LayoutWrapper>
                  <NewDemandeIdentification />
                </LayoutWrapper>
              </Suspense>
            }
          />
          {/* <Route
            path={PATH_ENTITE_DETAIL}
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <LayoutWrapper>
                  <DetailEntite />
                </LayoutWrapper>
              </Suspense>
            }
          /> */}
          {/*  <Route
            path={PATH_DETAIL_CAMPAGNE_INTERVENTION}
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <LayoutWrapper>
                  <DetailCampagneIntervention />
                </LayoutWrapper>
              </Suspense>
            }
          />
          <Route
            path={PATH_DETAIL_INTERVENTION}
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <LayoutWrapper>
                  <DetailIntervention />
                </LayoutWrapper>
              </Suspense>
            }
          />
          <Route
            path={PATH_DETAIL_LOT_INTERVENTION}
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <LayoutWrapper>
                  <DetailLotIntervention />
                </LayoutWrapper>
              </Suspense>
            }
          />
          <Route
            path={PATH_DETAIL_LOT_INTRANT}
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <LayoutWrapper>
                  <DetailLotIntrant />
                </LayoutWrapper>
              </Suspense>
            }
          />
          <Route
            path={PATH_DETAIL_SEMENCE}
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <LayoutWrapper>
                  <DetailSemence />
                </LayoutWrapper>
              </Suspense>
            }
          />
          <Route
            path={PATH_DETAIL_INSEMINATION}
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <LayoutWrapper>
                  <DetailInsemination />
                </LayoutWrapper>
              </Suspense>
            }
          />
          <Route
            path={PATH_DETAIL_MISE_BAS}
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <LayoutWrapper>
                  <DetailMisebas />
                </LayoutWrapper>
              </Suspense>
            }
          />
          <Route
            path={PATH_DETAIL_PRODUIT_MISE_BAS}
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <LayoutWrapper>
                  <DetailProduitMisebas />
                </LayoutWrapper>
              </Suspense>
            }
          /> */}
        </Route>

        <Route path="" element={<PublicRoutes /* routesData={routesData} */ />}>
          <Route
            path="/sign-in"
            element={
              <Suspense fallback={<SuspenceComponent />}>
                <SignIn />{" "}
              </Suspense>
            }
          />
        </Route>
      </Routes>
    </ThemeProvider>
  );
}
const ProtectedRoutes = () => {
  const auth = useAuth();
  // console.log("ProtectedRoutes called", auth);

  return auth ? <Outlet /> : <Navigate to="/sign-in" />;
};
const PublicRoutes = () => {
  const dataRes = [];

  const auth = useAuth();

  if (auth) {
    const UserInfo = localStorage.getItem(USER_DATA_STORAGE);
    let userRoles = [];
    if (UserInfo !== null) {
      userRoles = JSON.parse(UserInfo).roles;
    }
    routesData.forEach((i, idx, arr) => {
      const isAvalaible = i.role
        .map((el1) => ({
          name: el1,
          match: userRoles.some((el2) => el2.roleName === el1),
        }))
        .some((x) => x.match === true);
      if (isAvalaible) {
        dataRes.push(i);
      }
      if (idx === arr.length - 1) {
        return dataRes;
      }
      return "success";
    });
  }
  return dataRes.length > 0 ? <Navigate to={dataRes[0].route} /> : <Outlet />;
};
